import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { MenuProps } from 'antd/lib/menu';
import React, { FC, useEffect, useState } from 'react';
import './language-switcher.scss';
import { LanguageSwitcherProps } from '/react4xp/parts/language-switcher/language-switcher.type';

const LanguageSwitcher: FC<LanguageSwitcherProps> = (props: LanguageSwitcherProps) => {
    const items: MenuItemType[] = [
        {
            label: 'На русском',
            key: 'ru',
        },
        {
            label: 'Қазақша',
            key: 'kk',
        },
        {
            label: 'In English',
            key: 'en',
        },
    ];

    const [lang, setLang] = useState<any>(items[0]);

    const onClick: MenuProps['onClick'] = ({ key }) => {
        if (lang.key !== key) {
            const arr = window.location.href.split('/');
            const index = arr.indexOf(lang.key);

            if (index !== -1) {
                arr[index] = key;
                window.location.href = arr.join('/');
            } else {
                window.location.href =
                    arr.slice(0, 3).join('/') + `/${key}/` + arr.slice(3).join('/');
            }
        }
    };

    useEffect(() => {
        const langItem = items.find((x) => x.key === props.language);

        if (langItem) {
            setLang(langItem);
        }
    }, []);

    return (
        <div className="d-flex gap-3 align-items-center">
            <Dropdown
                menu={{ items, onClick }}
                className="language-switcher"
                trigger={['click']}
            >
                <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        {lang && lang.label}
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>
        </div>
    );
};

export default LanguageSwitcher;
